import { DEBRIS_ITEMS, TIER1_MATERIALS, TIER2_MATERIALS } from "./items";

// ── Enemy drop pools ──────────────────────────────────────────────────────────
// Each pool defines: raw items, matching tier-1 materials, and chance of tier-2 loot.
// Enemies are assigned a pool based on their tier; higher tiers have richer drops.

const item = id => DEBRIS_ITEMS.find(i => i.id === id);
const mat1  = id => TIER1_MATERIALS.find(m => m.id === id);
const mat2  = id => TIER2_MATERIALS.find(m => m.id === id);

export const ENEMY_DROP_POOLS = [
  // Pool 0 — "Scrapper" (tier 1, sector 0–3): starter salvage
  {
    raw:   [item("copper"), item("hull_debris"), item("glass_shard"), item("cable")],
    mat1:  [mat1("metal_alloy"), mat1("synth_alloy")],
    mat2:  null,
    echoChance: 1 / 5000,
  },
  // Pool 1 — "Reaver" (tier 2, sector 4–7): T2 mats + components
  {
    raw:   [item("silica_dust"), item("titanium_ore"), item("glass_shard"), item("panel")],
    mat1:  [mat1("optical_processor"), mat1("ionized_lens"), mat1("thermal_core")],
    mat2:  [mat2("nano_glass"), mat2("titanium_plates")],
    echoChance: 1 / 3000,
  },
  // Pool 2 — "Warlord" (tier 3, sector 8+): T3 mats + rare
  {
    raw:   [item("dark_matter"), item("living_metal"), item("plasma_condensate"), item("shard")],
    mat1:  [mat1("plated_wiring"), mat1("pressure_valve"), mat1("reinforced_frame")],
    mat2:  [mat2("enriched_cells"), mat2("warp_coolant"), mat2("kinetic_shielding")],
    echoChance: 1 / 1500,
  },
];

function poolForTier(tier) {
  if (tier >= 3) return 2;
  if (tier >= 2) return 1;
  return 0;
}

export function rollEnemyDrops(tier, sectorIndex) {
  const pool = ENEMY_DROP_POOLS[poolForTier(tier)];

  const rawCount = 2 + Math.floor(Math.random() * 3);
  const drops = [];
  const echoIds = [];
  for (let i = 0; i < rawCount; i++) {
    const pick = pool.raw[Math.floor(Math.random() * pool.raw.length)];
    if (!pick) continue;
    const qty  = 1 + Math.floor(Math.random() * 3) + Math.floor(sectorIndex / 4);
    drops.push({ ...pick, qty });
    if (Math.random() < pool.echoChance * qty) echoIds.push(pick.id);
  }

  const materialDrops = [];

  if (pool.mat1 && Math.random() < 0.40) {
    const validMat1 = pool.mat1.filter(Boolean);
    if (validMat1.length > 0) {
      const m = validMat1[Math.floor(Math.random() * validMat1.length)];
      const qty = 1 + Math.floor(Math.random() * 2);
      materialDrops.push({ ...m, qty, isMaterial: true });
    }
  }

  if (pool.mat2 && pool.mat2.length > 0) {
    const validMat2 = pool.mat2.filter(Boolean);
    if (validMat2.length > 0) {
      const t2Chance = 0.08 + tier * 0.06 + sectorIndex * 0.01;
      if (Math.random() < t2Chance) {
        const m = validMat2[Math.floor(Math.random() * validMat2.length)];
        materialDrops.push({ ...m, qty: 1, isMaterial: true });
      }
    }
  }

  return { drops, materialDrops, echoIds };
}
